import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="state"
export default class extends Controller {
  state = {}

  setState(newState) {
    this.state = { ...this.state, ...newState }

    if (this.render) {
      this.render()
    }
  }

  resetState() {
    this.setState({ files: [] })
  }
}
